import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import WordToPdfPage from './pages/WordToPdfPage';
import ImageToPdfPage from './pages/ImageToPdfPage';
import CompressPdfPage from './pages/CompressPdfPage';
import PdfToImagePage from './pages/PdfToImagePage';
import PdfToWordPage from './pages/PdfToWordPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import DisclaimerPage from './pages/DisclaimerPage';
import NotFoundPage from './pages/NotFoundPage';

import BlogIndexPage from './pages/blog/BlogIndexPage';
import PostWordToPdf from './pages/blog/post-word-to-pdf';
import PostPdfCompression from './pages/blog/post-pdf-compression';
import PostClientSideSafer from './pages/blog/post-client-side-safer';
import PostPdfToWordReality from './pages/blog/post-pdf-to-word-reality';
import PostPdfSecurity from './pages/blog/post-pdf-security';

function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route index element={<HomePage />} />

                <Route path="word-to-pdf" element={<WordToPdfPage />} />
                <Route path="image-to-pdf" element={<ImageToPdfPage />} />
                <Route path="compress-pdf" element={<CompressPdfPage />} />
                <Route path="pdf-to-image" element={<PdfToImagePage />} />
                <Route path="pdf-to-word" element={<PdfToWordPage />} />

                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="terms" element={<TermsPage />} />
                <Route path="disclaimer" element={<DisclaimerPage />} />

                <Route path="blog" element={<BlogIndexPage />} />
                <Route
                    path="blog/convert-word-to-pdf-without-losing-formatting"
                    element={<PostWordToPdf />}
                />
                <Route
                    path="blog/pdf-compression-lossless-vs-lossy"
                    element={<PostPdfCompression />}
                />
                <Route
                    path="blog/client-side-document-processing-is-safer"
                    element={<PostClientSideSafer />}
                />
                <Route
                    path="blog/pdf-to-word-what-actually-works"
                    element={<PostPdfToWordReality />}
                />
                <Route
                    path="blog/complete-guide-to-pdf-file-security"
                    element={<PostPdfSecurity />}
                />

                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    );
}

export default App;
